import styled, {css} from "styled-components/macro";
import {device} from "../../styles";
import {IsCollapsed, IsVisibleOnMobile} from "../../data";
import IconCollapseButton from "../Icons/IconCollapseButton";

export const Root = styled.section<IsVisibleOnMobile>`
    border: 1px solid var(--color-border-dropdown);

    ${device.less768} {
        border: none;
        display: none;
        
        ${(props) => props.$isVisibleOnMobile && css`
            display: block;
        `}
    }
`;

export const Head = styled.div`
    width: 100%;
    min-height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    padding: 0 30px;
    user-select: none;
    

    ${device.less1180} {
        min-height: 42px;
        padding: 0 20px;
    }

    ${device.less768} {
        min-height: auto;
        cursor: default;
        padding: 0;
    }
`;

export const Title = styled.div`
    color: var(--color-accent);
    font-family: LatoWebSemibold, sans-serif;
    font-size: 16px;
    font-style: normal;
    line-height: 28px;
    text-transform: uppercase;

    ${device.less1180} {
        font-size: 12px;
    }
    
    &:after {
        content: " *";
    }
`;

export const Toggler = styled.span<IsCollapsed>`
    width: 13px;
    height: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform-origin: center center;
    transition: transform 0.6s;
    margin-left: auto;

    ${(props) => props.$isCollapsed && css`
        transform: rotate(180deg);
    `}

    ${device.less1180} {
        width: 10px;
        height: 10px;
    }

    ${device.less768} {
        display: none;
    }
`;

export const Icon = styled(IconCollapseButton)<IsCollapsed>`
    ${(props) => props.$isCollapsed
        ? css`fill: var(--color-border-dropdown);`
        : css`fill: var(--color-accent);`
    }
`;

export const Body = styled.div<IsCollapsed>`
    transition: all 0.3s;
    padding: 5px 30px 20px 30px;

    ${device.less1180} {
        padding: 5px 20px 15px 20px;
    }

    ${device.less768} {
        padding: 0;
    }

    ${(props) => props.$isCollapsed && css`
        opacity: 0.0001;
        height: 0 !important;
        pointer-events: none;
        padding: 0;

        ${device.less768} {
            opacity: 1;
            height: 100% !important;
            padding: 12px 0;
            pointer-events: auto;
        }
    `}
`;
